import http from './ApiConfig';
import { Service } from './Service';

export interface AdesaoDose {
  guiaMedicamentoItemId: number;
  medicamento: string;
  rotulo: string;
  horario: string;
  dosagem: string | null;
  confirmada: boolean;
}

export interface AdesaoDosesDia {
  data: string;
  doses: AdesaoDose[];
}

export interface AdesaoRelatorioMedicamento {
  guiaMedicamentoItemId: number;
  medicamento: string;
  dosesEsperadas: number;
  dosesConfirmadas: number;
  percentualAdesao: number;
}

export interface AdesaoRelatorio {
  pacienteId: number;
  de: string;
  ate: string;
  dosesEsperadas: number;
  dosesConfirmadas: number;
  percentualAdesao: number;
  porMedicamento: AdesaoRelatorioMedicamento[];
}

// C3 — Adesão ao tratamento.
// Backend: api/adesao (doses/confirmar são públicos gated por token JWT de escopo
// "adesao"; relatório exige AdesaoTratamentoRead).
export class AdesaoService extends Service {
  constructor() {
    super('api/adesao');
  }

  // Público (paciente, sem login): doses do dia do link. O token JWT É a credencial.
  public Doses(token: string) {
    return http.get(`${this._nomeControle}/doses`, {
      ...this.GetHeader(),
      params: { token },
    });
  }

  // Público: confirma UMA dose (item da guia + horário). Clique repetido é ok
  // silencioso no backend (índice único garante idempotência).
  public Confirmar(token: string, guiaMedicamentoItemId: number, horario: string) {
    return http.post(
      `${this._nomeControle}/confirmar`,
      { token, guiaMedicamentoItemId, horario },
      this.GetHeader(),
    );
  }

  // Interno (staff, AdesaoTratamentoRead): relatório de adesão do paciente no período.
  public Relatorio(pacienteId: number, de?: string, ate?: string) {
    const params: Record<string, unknown> = {};
    if (de) params.de = de;
    if (ate) params.ate = ate;
    return http.get(`${this._nomeControle}/relatorio/paciente/${pacienteId}`, {
      ...this.GetHeader(),
      params,
    });
  }
}

export default AdesaoService;
